import { render, staticRenderFns } from "./AddCoreFields.vue?vue&type=template&id=7090c400"
import script from "./AddCoreFields.vue?vue&type=script&lang=js"
export * from "./AddCoreFields.vue?vue&type=script&lang=js"
import style0 from "./AddCoreFields.vue?vue&type=style&index=0&id=7090c400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports